import React from "react";

const SpinnerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM3.03345 12C3.03345 16.9521 7.04791 20.9665 12 20.9665C16.9521 20.9665 20.9665 16.9521 20.9665 12C20.9665 7.04791 16.9521 3.03345 12 3.03345C7.04791 3.03345 3.03345 7.04791 3.03345 12Z"
        fill="#F8FAFC"
      />
      <path
        d="M22.4843 11.9997C23.3214 11.9997 24.0099 11.3185 23.9044 10.488C23.5712 7.86294 22.3764 5.40559 20.4853 3.51445C18.2348 1.26402 15.1826 -0.000264881 12 -0.000265121C8.8174 -0.000265362 5.76516 1.26402 3.51472 3.51445C1.62358 5.40559 0.428846 7.86294 0.0955515 10.488C-0.00988021 11.3184 0.67858 11.9997 1.51565 11.9997C2.35272 11.9997 3.01824 11.3164 3.15904 10.4912C3.46939 8.67234 4.33609 6.97999 5.65817 5.65791C7.34013 3.97595 9.62135 3.03104 12 3.03104C14.3786 3.03104 16.6599 3.97595 18.3418 5.65791C19.6639 6.97999 20.5306 8.67234 20.841 10.4912C20.9818 11.3164 21.6473 11.9997 22.4843 11.9997Z"
        fill="#18222F"
      />
    </svg>
  );
};

export default SpinnerIcon;
